import _hasIn from 'lodash/hasIn';
import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformV2ClientResponse, transformKeysToSnakeCase } from 'helpers/core';
import URLS from 'constants/urls';

const UPLOAD_RETRY_LIMIT = 3;

const uploadPhoto = (client, venueId, photoData, attempt = 1) =>
  client
    .post(URLS.venue.carouselPhotos(venueId), transformKeysToSnakeCase(photoData), {
      ignoreInternalError: true,
    })
    .catch(error => {
      if (attempt <= UPLOAD_RETRY_LIMIT) {
        return uploadPhoto(client, venueId, photoData, attempt + 1);
      }
      throw error;
    });

const handler = ({ httpClient }, venueId, photoData) => {
  const endpoint = URLS.venue.carouselPhotos(venueId);

  if (!photoData) {
    return httpClient.get(endpoint).then(transformV2ClientResponse);
  }
  if (_hasIn(photoData, 'mediaOrder')) {
    return httpClient
      .patch(URLS.venue.updateCarouselPhotosOrder(venueId), transformKeysToSnakeCase(photoData))
      .then(transformV2ClientResponse);
  }
  return uploadPhoto(httpClient, venueId, photoData).then(() =>
    httpClient.get(endpoint).then(transformV2ClientResponse)
  );
};

export default makeEntityScaffold('VENUE_PAGE_ADDITIONAL_PHOTOS', handler, {
  defaultKey: (client, venueId) => venueId,
});
